import React from "react";
import ExperienceComponent from "./ExperienceComponent";

const Contact = () => {
  return (
    <div>
      <div className="container">
        <div className="row">
          <div className="col-12 blah">.</div>
          <div className="col-12 blah">.</div>
          {/* <div className="col-1">.</div> */}
          <div className="col-12">
            <h1
              style={{
                color: "white",
                display: "flex",
                justifyContent: "center",
                marginRight: "10px",
              }}
            >
              {/* c895e0 */}
              <span style={{ color: "#c895e0" }}>Thanks for react</span>
              <span style={{ color: "#c0c0c0" }}>-ing!</span>
            </h1>
          </div>
        </div>
        <div className="row">
          <div className="col-12">.</div>
          <div className="col-12">.</div>
          <div
            className="col-12"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div
              style={{
                width: 698,
                height: 250,
                left: 430,
                top: 250,
                // position: "absolute",
                backgroundColor: "transparent",
                borderRadius: 5,
                boxShadow: "6px 6px 4px rgba(0, 0, 0, 0.25)",
                borderWidth: "1px",
                borderStyle: "groove",
                borderColor: "#c895e0",
              }}
            >
              <div className="container">
                <div className="row">
                  <div className="col-12">.</div>
                </div>
                <div className="row">
                  <div
                    className="col-3"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0 6C0 4.34315 1.34315 3 3 3H21C22.6569 3 24 4.34315 24 6V18C24 19.6569 22.6569 21 21 21H3C1.34315 21 0 19.6569 0 18V6ZM3 4.5C2.17157 4.5 1.5 5.17157 1.5 6V6.32536L12 12.6254L22.5 6.32536V6C22.5 5.17157 21.8284 4.5 21 4.5H3ZM22.5 8.07464L15.4379 12.3119L22.5 16.6578V8.07464ZM22.4494 18.3879L13.9887 13.1814L12 14.3746L10.0113 13.1814L1.55065 18.3879C1.72162 19.0283 2.30573 19.5 3 19.5H21C21.6943 19.5 22.2784 19.0283 22.4494 18.3879ZM1.5 16.6578L8.56211 12.3119L1.5 8.07464V16.6578Z"
                        fill="#C895E0"
                      />
                    </svg>
                  </div>
                  <div
                    className="col-3"
                    style={{
                      color: "#c0c0c0",
                      fontSize: "18px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    EMAIL ID
                  </div>
                  <div
                    className="col-6"
                    style={{
                      color: "#c0c0c0",
                      fontSize: "18px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    div5353@gmail.com
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">.</div>
                </div>
                <div className="row">
                  <div
                    className="col-3"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M24 20.6667C24 22.508 22.508 24 20.6667 24H3.33333C1.49267 24 0 22.508 0 20.6667V3.33333C0 1.492 1.49267 0 3.33333 0H20.6667C22.508 0 24 1.492 24 3.33333V20.6667Z"
                        fill="#767171"
                      />
                      <path
                        d="M5 8.375H8.125V19H5V8.375ZM6.55312 7.125H6.53562C5.60312 7.125 5 6.43 5 5.56187C5 4.675 5.62187 4 6.57125 4C7.52187 4 8.1075 4.675 8.125 5.56187C8.125 6.42937 7.52187 7.125 6.55312 7.125ZM20 19H16.875V13.3131C16.875 11.9394 16.1094 11.0019 14.88 11.0019C13.9419 11.0019 13.4344 11.6344 13.1881 12.2456C13.0981 12.4644 13.125 13.0694 13.125 13.375V19H10V8.375H13.125V10.01C13.5756 9.3125 14.2813 8.375 16.0863 8.375C18.3225 8.375 19.9994 9.78125 19.9994 12.9213L20 19Z"
                        fill="#1E1C16"
                      />
                    </svg>
                  </div>
                  <div
                    className="col-3"
                    style={{
                      color: "#c0c0c0",
                      fontSize: "18px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    LINKEDIN
                  </div>
                  <div
                    className="col-6"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <a
                      target="_blank"
                      href="https://www.linkedin.com/in/divyashree-lochan/"
                      style={{
                        color: "#c0c0c0",
                        backgroundColor: "transparent",
                      }}
                    >
                      linkedin.com/divyashree
                    </a>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">.</div>
                </div>
                <div className="row">
                  <div
                    className="col-3"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 0C5.37 0 0 5.50583 0 12.3035C0 17.7478 3.435 22.3463 8.205 23.9765C8.805 24.0842 9.03 23.715 9.03 23.3921C9.03 23.0999 9.015 22.131 9.015 21.1005C6 21.6696 5.22 20.347 4.98 19.6549C4.845 19.3012 4.26 18.2092 3.75 17.917C3.33 17.6863 2.73 17.1173 3.735 17.1019C4.68 17.0865 5.355 17.9939 5.58 18.363C6.66 20.2239 8.385 19.701 9.075 19.3781C9.18 18.5783 9.495 18.04 9.84 17.7325C7.17 17.4249 4.38 16.3637 4.38 11.6576C4.38 10.3196 4.845 9.21226 5.61 8.35102C5.49 8.04343 5.07 6.78232 5.73 5.09058C5.73 5.09058 6.735 4.76762 9.03 6.3517C9.99 6.07487 11.01 5.93645 12.03 5.93645C13.05 5.93645 14.07 6.07487 15.03 6.3517C17.325 4.75224 18.33 5.09058 18.33 5.09058C18.99 6.78232 18.57 8.04343 18.45 8.35102C19.215 9.21226 19.68 10.3042 19.68 11.6576C19.68 16.3791 16.875 17.4249 14.205 17.7325C14.64 18.1169 15.015 18.8552 15.015 20.0086C15.015 21.6542 15 22.9768 15 23.3921C15 23.715 15.225 24.0995 15.825 23.9765C18.2072 23.1519 20.2773 21.5822 21.7438 19.4882C23.2103 17.3942 23.9994 14.8814 24 12.3035C24 5.50583 18.63 0 12 0Z"
                        fill="#767171"
                      />
                    </svg>
                  </div>
                  <div
                    className="col-3"
                    style={{
                      color: "#c0c0c0",
                      fontSize: "18px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    GITHUB
                  </div>
                  <div
                    className="col-6"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <a
                      target="_blank"
                      href="https://github.com/divyeahh"
                      style={{
                        color: "#c0c0c0",
                        backgroundColor: "transparent",
                      }}
                    >
                      github.com/divyeahh
                    </a>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">.</div>
                </div>
                <div className="row">
                  <div
                    className="col-3"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.76884 5.15625C10.5072 5.15625 13.5374 8.20768 13.5374 11.9715C13.5374 15.7354 10.5069 18.7866 6.76884 18.7866C3.03073 18.7866 0 15.7354 0 11.9715C0 8.20768 3.0305 5.15625 6.76884 5.15625ZM17.5782 5.55547C19.4474 5.55547 20.9626 8.42775 20.9626 11.9715H20.9628C20.9628 15.5144 19.4476 18.3876 17.5784 18.3876C15.7092 18.3876 14.194 15.5144 14.194 11.9715C14.194 8.42867 15.709 5.55547 17.5782 5.55547ZM22.8097 6.22375C23.4669 6.22375 24 8.79708 24 11.9715C24 15.1451 23.4672 17.7193 22.8097 17.7193C22.1522 17.7193 21.6196 15.1458 21.6196 11.9715C21.6196 8.79731 22.1524 6.22375 22.8097 6.22375Z"
                        fill="#C895E0"
                      />
                    </svg>
                  </div>
                  <div
                    className="col-3"
                    style={{
                      color: "#c0c0c0",
                      fontSize: "18px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    MEDIUM
                  </div>
                  <div
                    className="col-6"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <a
                      target="_blank"
                      href="https://medium.com/@div5353"
                      style={{
                        color: "#c0c0c0",
                        backgroundColor: "transparent",
                      }}
                    >
                      medium.com/@div5353
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
